/**
 * replaceCustomReviews
 *
 * This function replaces the default product review stars with custom styled stars after a delay.
 * It finds all review containers, gets the rating number from the aria-label attribute,
 * sets the rating text, and shows the custom stars.
 */
let counterReviewsContainer = 0;

function replaceCustomReviews() {
  const reviewsContainers = document.querySelectorAll(".kl_reviews__star_rating_widget");
  const reviewsHeading = document.querySelector('[data-name="reviews-heading"]');
  if (document.querySelector(".kl_reviews__star_rating_widget__label").textContent.indexOf('reviews') > -1) {
    reviewsHeading.textContent = "(" + document.querySelector(".kl_reviews__star_rating_widget__label").textContent + ")";
    reviewsContainers.forEach((review) => {
      const regex = /(\d+(\.\d+)?)\sstars/;
      let text = review.getAttribute("aria-label");
      let match = text.match(regex);
      let rating = match[1];
      const childSpan = document.createElement('span');
      childSpan.textContent = Number(rating).toFixed(1);
      childSpan.classList.add("kl_reviews__star_rating_widget__label");
      review.querySelector(".kl_reviews__star_rating_widget__label").parentElement.appendChild(childSpan);
      childSpan.classList.add("show");
      review.addEventListener('click', () => document.querySelector('[data-value="accordion-reviews"]').classList.add("active"));
    });
  }
}

function observeRatingWrapper() {
  const observer = new MutationObserver(function (mutations, observerInstance) {
    if (document.querySelector('.kl_reviews__reviews_list')) {
      replaceCustomReviews();
      observerInstance.disconnect();
    }
  });
  observer.observe(document.querySelector(".accordion__content--reviews"), { childList: true, subtree: true });
}
observeRatingWrapper();

// Function to check if reviews accordion should be hidden or shown
function hideReviewsAccordionIfEmpty() {
  const reviewsWrapper = document.querySelector("#klaviyo-product-reviews-wrapper");

  if (reviewsWrapper) {
    if (reviewsWrapper.innerHTML !== "") {
      document.querySelector('[data-value="accordion-reviews"]').removeAttribute("hidden");
    }
  } else {
    counterReviewsContainer++;
    if (counterReviewsContainer < 20) {
      observeReviewsContainer(); // Continue observing if element not found
    }
  }
}

function observeReviewsContainer() {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (document.querySelector("#klaviyo-product-reviews-wrapper")) {
        hideReviewsAccordionIfEmpty();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true // Ensure it catches nested elements being added
  });
}
observeReviewsContainer();